import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * @typedef {Object} Refs
 * @property {HTMLSelectElement} stateSelect
 * @property {HTMLElement} fill
 * @property {HTMLElement} message
 *
 * @extends {Component<Refs>}
 */
export class FreeShippingBar extends Component {
  requiredRefs = ['fill', 'message'];
  storageKey = 'beas-shipping-state';

  connectedCallback() {
    super.connectedCallback();

    /** @type {Record<string, number>} */
    this.thresholds = JSON.parse(this.getAttribute('data-thresholds') || '{}');
    this.defaultThreshold = Number(this.getAttribute('data-default-threshold') || 0);
    this.textBefore = this.getAttribute('data-text-before') || '';
    this.textSuccess = this.getAttribute('data-text-success') || '';

    const savedState = window.localStorage.getItem(this.storageKey);
    if (savedState && this.refs.stateSelect) {
      this.refs.stateSelect.value = savedState;
    }

    this.refs.stateSelect?.addEventListener('change', () => {
      if (this.refs.stateSelect.value) {
        window.localStorage.setItem(this.storageKey, this.refs.stateSelect.value);
      }
      this.update();
    });

    document.addEventListener(ThemeEvents.cartUpdate, (/** @type {CustomEvent} */ event) => {
      this.cartTotal = event.detail?.resource?.total_price ?? this.cartTotal;
      this.update();
    });

    fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
      .then((response) => response.json())
      .then((cart) => {
        this.cartTotal = cart.total_price;
        this.update();
      })
      .catch(() => {
        this.cartTotal = 0;
        this.update();
      });
  }

  getThreshold() {
    const state = this.refs.stateSelect?.value;
    if (state && this.thresholds[state] != null) {
      return this.thresholds[state];
    }
    return this.defaultThreshold;
  }

  update() {
    const thresholdCents = this.getThreshold() * 100;
    const total = this.cartTotal ?? 0;

    if (thresholdCents <= 0) {
      this.hidden = true;
      return;
    }

    this.hidden = false;
    const percent = Math.min(100, Math.round((total / thresholdCents) * 100));
    this.refs.fill.style.width = `${percent}%`;

    if (total >= thresholdCents) {
      this.refs.message.textContent = this.textSuccess;
      this.classList.add('free-shipping-bar--complete');
    } else {
      const remaining = (thresholdCents - total) / 100;
      const formatted = remaining.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      this.refs.message.textContent = `${this.textBefore} ${formatted}`;
      this.classList.remove('free-shipping-bar--complete');
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
